import React from "react";
import styled from 'styled-components';

import config from "../../Config";
import i18n from "../../i18n";

const Container = styled.div`
	display: flex;
    position: fixed;
    bottom: 0px;
    width: 100%;
    background-color: #ffff;
    border-top: 1px solid lightgrey;
    justify-content: space-between;
    padding: 5px;
    height: 80px
`;

const InfoWraper = styled.div`
	width: 100%;
`;

const UniqueBid = styled.div`
	display: flex;
	padding: 5px 20px;
`;

const RepeatedBid = styled.div`
	display: flex;
	padding: 5px 20px;
	justify-content: flex-end;
`;

const Close = styled.div`
	margin: 10px;
`;

const Text = styled.span`
	font-size: 14px;
`;

const AboutBidding = ({hideAboutBidding}) => {

	return <Container className="setWidth">
		<InfoWraper>
			<UniqueBid>
            	<img src={`${config.MRBIDNWIN_S3_IMAGE_URL}/unique-bid.svg`} alt="Unique-Bid"/>
            	<Text className="montserratRegular" style={{ color: "#2EBAAA"}}>{i18n.t("UniqueBids")}</Text>
			</UniqueBid>
			<RepeatedBid>
            	<img src={`${config.MRBIDNWIN_S3_IMAGE_URL}/repeated-bid.svg`} alt="Repeated-Bid"/>
            	<Text className="montserratRegular" style={{color: "#FF9C9C"}}>{i18n.t("RepeatedBids")}</Text>
			</RepeatedBid>
		</InfoWraper>
		<Close onClick={hideAboutBidding}>
			<img src={`${config.MRBIDNWIN_S3_IMAGE_URL}/bid_close.svg`} alt="bid-close"/> 
		</Close>
	</Container>
}

export default AboutBidding;




// WEBPACK FOOTER //
// ./src/views/MyBids/AboutBidding.js